import { FeatureSectionType } from "../../components/types";

export const getFeatureSections = (): FeatureSectionType[] => [
  {
    src: "",
    fallbackSrc: "/landing_page_assets/telehealth/connect.png",
    title: "The Problem",
    description: [
      "Unsigned orders don't just slow you down, they cost you.",
    ],
    features: [
      {
        icon: "/landing_page_assets/icons/List.svg",
        text: "Orders miss filing deadlines → revenue lost",
      },
      {
        icon: "/landing_page_assets/icons/BluePlus.svg",
        text: "Staff spend hours calling, refaxing, and following up",
      },
      {
        icon: "/landing_page_assets/icons/SearchCheck.svg",
        text: "No clear visibility into what signatures are still outstanding",
      },
    ],
    hasButton: false,
    imageClassName: "tw-max-w-[440px] tw-max-h-[577px] tw-rounded-[32px]",
  },
  {
    src: "",
    fallbackSrc: "/landing_page_assets/telehealth/insurance.jpg",
    title: "The Solution",
    description: ["Verse handles signature collection end-to-end."],
    className: "min440:tw-flex-row-reverse",
    features: [
      {
        icon: "/landing_page_assets/icons/minusIcon.svg",
        text: "Captures revenue before deadlines pass",
      },
      {
        icon: "/landing_page_assets/icons/Bolt.svg",
        text: "Eliminates manual follow up for your team",
      },
      {
        icon: "/landing_page_assets/icons/SearchCheck.svg",
        text: "Gives real-time visibility into every order",
      },
    ],
    hasButton: false,
    imageClassName: "tw-max-w-[440px] tw-max-h-[577px] tw-rounded-[32px]",
  },
  {
    src: "",
    fallbackSrc: "/landing_page_assets/telehealth/coverage.jpg",
    title: "How It Works",
    description: ["Verse handles the entire signature collection workflow."],
    features: [
      {
        icon: "/landing_page_assets/icons/Route.svg",
        text: "Outreach across fax, phone, and digital channels",
      },
      {
        icon: "/landing_page_assets/icons/Sparkle.svg",
        text: "Automatically corrects provider contact information",
      },
      {
        icon: "/landing_page_assets/icons/List.svg",
        text: "No physician onboarding or setup required",
      },
      {
        icon: "/landing_page_assets/icons/Heart.svg",
        text: "Engages physicians through their preferred channels",
      },
    ],
    hasButton: false,
    imageClassName: "tw-max-w-[440px] tw-max-h-[594px] tw-rounded-[32px]",
  },
];
